<template>
  <div>
    <v-container
      class="px-0"
    >
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <!--          header start-->
        <v-row
          v-show="step === 'header'"
          class="mx-0 px-0 mt-0"
        >
          <v-col
            cols="6"
            class="py-0 d-flex"
          >
            <v-checkbox
              v-if="type === 'returnSell'"
              v-model="wastageReturnSell"
              :label="$t('wastage')"
              class="mt-2"
              value="active"
            />
          </v-col>
          <v-col
            cols="6"
            class="py-0 d-flex flex-row-reverse"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  icon
                  v-on="on"
                  @click="moreDialog = true"
                >
                  <v-icon
                    color="primary"
                    style="font-size: 22px"
                  >
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('more') }}</span>
            </v-tooltip>
          </v-col>
          <v-col
            cols="12"
          >
            <m-autocomplete
              v-model="account"
              :title="(type == 'purchase' || type == 'returnPurchase' ? $t('detail') : $t('customer'))"
              type="person"
              :new-btn="true"
              :rules="[v => !!v || isRequiredMessage((type == 'purchase' || type == 'returnPurchase' ? $t('detail') : $t('customer')))]"
              :offline="true"
              :value="account"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <template>
              <v-text-field
                id="from"
                v-model="date"
                :label="$t('date')"
                :rules="[v => !!v || isRequiredMessage($t('date'))]"
                clear-icon="flaticon2-close-cross"
                outlined
                hide-details
                height="45"
                clearable
              />
              <date-picker
                v-model="date"
                element="from"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :min="$store.state.startDate"
                :max="$store.state.endDate"
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            v-show="more"
            cols="12"
          >
            <m-autocomplete
              v-model="entrepot"
              title="entrepot"
              type="entrepot"
              :rules="[v => !!v || isRequiredMessage($t('entrepot'))]"
              :set-init="(id ? false : true)"
              :value="entrepot"
              :offline="true"
            />
          </v-col>
          <v-col
            v-show="more"
            cols="12"
          >
            <template>
              <v-text-field
                id="dueDateId"
                v-model="dueDate"
                :label="$t('dueDate')"
                clear-icon="flaticon2-close-cross"
                outlined
                height="45"
                clearable
                @keyup="dueDate = null"
              />

              <date-picker
                v-model="dueDate"
                element="dueDateId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :min="date"
                :max="$store.state.endDate"
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <div
            align="center"
            style="margin-left: auto;margin-right: auto;"
          >
            <v-btn
              :color="(more ? 'primary' : 'primary')"
              fab
              dark
              small
              class="mt-3"
              style="margin-left: auto;margin-right: auto;"
              @click="more = !more"
            >
              <v-icon
                style="font-size: 26px"
                dark
              >
                {{ (more ? 'mdi-chevron-up' : 'mdi-chevron-down') }}
              </v-icon>
            </v-btn>
          </div>
        </v-row>
        <!--          header end-->
        <!--          body start-->
        <v-row
          v-show="step === 'body'"
          class="mx-0 px-0 mt-0"
        >
          <v-col
            cols="12"
            class="pa-0"
          >
            <products
              ref="productRef"
              v-model="items"
              :data="JSON.stringify({entrepot : (entrepot ? entrepot.id : null)})"
              :type-prop="type"
              :sum-amount="sumAmount"
              :height-prop="height"
              :show-selected-items="showSelectedItems"
              @showSelectedItems="showSelectedItems = !showSelectedItems"
            />
          </v-col>
        </v-row>
        <!--          body end-->
        <!--          final start-->
        <v-row
          v-show="step === 'final'"
          class="mx-0 px-2 mt-0 mb-1"
        >
          <p
            style="width: 100%;font-size: 20px;border-bottom: 1px solid #e3e3e3;"
            class="text-center pb-3 mb-0"
          >
            {{ $t('itemsList') }}
          </p>
          <v-divider />
        </v-row>
        <v-row
          v-show="step === 'final'"
          class="mx-0 px-0 mt-2"
          style="overflow-y: scroll;overflow-x: hidden;border-bottom: 0px solid #e3e3e3;height: calc(100vh - 210px)"
        >
          <product-selected
            :noscroll="true"
            :selected-items="items"
          />
          <v-divider />
          <div
            style="width: 100%"
            class="d-flex mt-8 px-2"
          >
            <p
              style="width: 50%;font-size: 18px"
              class="text-right mb-1"
            >
              {{ $t('whole') }}
            </p>
            <p
              style="width: 50%;font-size: 18px"
              class="text-left mb-1"
            >
              {{ $numberFormat(sumAmount) }} {{ $store.state.currency.name }}
            </p>
          </div>
          <div
            style="width: 100%"
            class="d-flex  px-2"
          >
            <p
              style="width: 50%;font-size: 18px"
              class="text-right mb-1"
            >
              {{ $t('tax') }}
            </p>
            <p
              style="width: 50%;font-size: 18px"
              class="text-left mb-1"
            >
              {{ $numberFormat(tax) }} {{ $store.state.currency.name }}
            </p>
          </div>
          <div
            style="width: 100%"
            class="d-flex  px-2"
          >
            <p
              style="width: 50%;font-size: 18px"
              class="text-right mb-1"
            >
              {{ $t('remainAmountCustomer') }}
            </p>
            <p
              style="width: 50%;font-size: 18px;color: red"
              class="text-left mb-1"
            >
              {{ $numberFormat((account ? account.amount : 0)) }} {{ $store.state.currency.name }}
            </p>
          </div>
          <div
            style="width: 100%"
            class="d-flex  px-2"
          >
            <p
              style="width: 50%;font-size: 18px"
              class="text-right mb-1"
            >
              {{ $t('payedPrice') }}
            </p>
            <p
              style="width: 50%;font-size: 18px"
              class="text-left mb-1"
            >
              {{ $numberFormat(payedAmount) }} {{ $store.state.currency.name }}
            </p>
          </div>
          <div
            style="width: 100%"
            class="d-flex px-2"
          >
            <p
              style="width: 50%;font-size: 18px"
              class="text-right mb-1"
            >
              {{ $t('totalSum') }}
            </p>
            <p
              style="width: 50%;font-size: 18px"
              class="text-left mb-1"
            >
              <strong style="color: rgb(76, 175, 80);font-size: 20px">{{ $numberFormat(+tax + +sumAmount) }}</strong> {{ $store.state.currency.name }}
            </p>
          </div>
        </v-row>
        <!--          final end-->
      </v-form>
    </v-container>
    <v-dialog
      v-model="moreDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="moreDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          cols="12"
          class="mt-3"
        >
          <p
            style="font-size: 20px;"
            class="text-center blue-grey--text text--darken-1"
          >
            {{ $t('addtional-information') }}
          </p>
        </v-col>
        <v-col
          cols="12"
        >
          <m-autocomplete
            v-model="currency"
            :title="$t('currency')"
            type="currency"
            :init="defaultCurrency"
            :value="currency"
          />
        </v-col>
        <v-col
          cols="12"
          class="mb-9"
        >
          <money
            v-model="currency_amount"
            :label="$t('currency-rate')"
            :dense="true"
            :outlined="true"
            :solo="false"
            height="45"
            :clearable="true"
            value-when-is-empty=""
            :options="options"
          />
        </v-col>
        <v-col
          cols="12"
        >
          <m-autocomplete
            v-model="branch"
            title="branch"
            type="branch"
            :set-init="true"
            :val="branch"
          />
        </v-col>
        <v-card-actions class="px-3">
          <v-row class="mx-0">
            <v-btn
              block
              height="45"
              color="pink accent-2"
              class="mt-4"
              @click="moreDialog = false"
            >
              {{ $t('close') }}
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 100000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
    <v-footer
      v-show="step == 'header' || (step == 'body' && items.length > 0) || step == 'final'"
      class="px-0 pt-0"
      absolute
      style="box-shadow: 1px 0 10px rgba(51,51,51,.251);"
    >
      <v-card
        v-if="step == 'header'"
        width="100%"
        flat
        class="my-0 px-2 pa-0 d-flex justify-space-between"
      >
        <v-btn
          block
          height="45"
          class="mx-3"
          color="primary"
          elevation="2"
          :loading="loading"
          style="font-size: 18px;margin: 9px"
          @click="step = 'body'"
        >
          {{ $t('continue') }}
        </v-btn>
      </v-card>
      <v-card
        v-if="step == 'body' && items.length > 0"
        width="100%"
        flat
        style="margin: 8px"
        class="my-0 pa-1 d-flex justify-space-between"
      >
        <v-card
          class="pa-2 pt-1 my-0"
          flat
          height="40"
          style="background-color: transparent;font-size: 16px;"
        >
          {{ items.length }} {{ $t('productInList') }}
          <span
            style="font-weight: bold;color: #4CAF50"
            @click="showSelectedItems = !showSelectedItems"
          >({{ $t('showList') }})</span>
        </v-card>
        <v-card
          class="pa-2 pt-1 my-0"
          flat
          height="40"
          style="font-size: 16px;background-color: transparent;"
        >
          {{ $numberFormat(sumAmount) }} {{ $store.state.currency.symbol }}
        </v-card>
      </v-card>
      <v-card
        v-if="step == 'body' && items.length > 0"
        width="100%"
        flat
        class="my-0 pa-0 px-2 d-flex justify-space-between"
      >
        <v-btn
          v-show="step == 'body'"
          block
          height="40"
          color="primary"
          elevation="2"
          width="150"
          style="font-size: 16px"
          :loading="loading"
          @click="step = 'final'"
        >
          {{ $t('continue') }}
        </v-btn>
      </v-card>
      <v-card
        v-if="step == 'final'"
        width="100%"
        flat
        class="my-0 pa-0 px-2 d-flex justify-space-between"
      >
        <v-card
          class="pa-2 pt-0 my-0"
          flat
          height="45"
        >
          <v-btn
            block
            height="40"
            color="green"
            elevation="2"
            :disabled="!paymentButton || paymentButtonStatus"
            width="150"
            class="mt-2"
            style="font-size: 16px"
            :loading="loading"
            @click="setPaymentMode"
          >
            {{ $t('receiveCash') }}
          </v-btn>
        </v-card>
        <v-card
          class="pa-2 pt-0 my-0"
          flat
          height="45"
        >
          <v-btn
            v-show="step == 'final' && !ouid"
            block
            height="40"
            color="primary"
            style="font-size: 16px"
            class="mt-2"
            :disabled="(!items || items.length === 0 ? true : false)"
            :loading="loading"
            @click="createIdInvoice"
          >
            {{ $t('finalSubmit') }}
          </v-btn>
          <v-btn
            v-show="step == 'final' && ouid"
            block
            height="40"
            color="primary"
            style="font-size: 16px"
            class="mt-2"
            :disabled="(!items || items.length === 0 ? true : false)"
            :loading="loading"
            @click="update"
          >
            {{ $t('finalSubmit') }}
          </v-btn>
        </v-card>
      </v-card>
    </v-footer>
    <v-dialog
      v-model="loadingDialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <p
            style="color: white"
            class="text-center"
          >
            {{ $t(loadingText) }} ...
          </p>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="paymentModeDialog"
      width="95%"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="paymentModeDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="pt-0"
        >
          <v-btn
            block
            height="40"
            color="blue"
            elevation="2"
            width="150"
            class="mt-2"
            style="font-size: 16px"
            @click="sendInvoiceToPos('remainCustomer')"
          >
            {{ $t('remainCustomer') }} : {{ $numberFormat((account ? account.amount : 0)) }} {{ $store.state.currency.name }}
          </v-btn>
        </v-col>
        <v-col
          class="pt-0"
        >
          <v-btn
            block
            height="40"
            color="blue"
            elevation="2"
            width="150"
            class="mt-2"
            style="font-size: 16px"
            @click="sendInvoiceToPos('remainInvoice')"
          >
            {{ $t('remainInvoice') }} : {{ $numberFormat(sumAmount) }} {{ $store.state.currency.name }}
          </v-btn>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Confirm ref="confirm" />
  </div>
</template>

<script>
  import General from '../../../../Mixins/general'
  import total from '@/views/dashboard/pages/accounting/total.vue'
  export default {
    name: 'MobileInvoices',
    components: {
      Products: () => import('../../components/general/Products/mProduct.vue'),
      ProductSelected: () => import('../../components/general/Products/mProductSeleted.vue'),
    },
    mixins: [General],
    props: ['input'],
    data: () => ({
      selected: [],
      paymentModeDialog: false,
      paymentModePrice: 0,
      wastageReturnSell: false,
      loadingText: null,
      height: 0,
      tax: 0,
      loadingDialog: false,
      sendPOS: false,
      deletDialog: false,
      moreDialog: false,
      showFilter: false,
      render: false,
      valid: true,
      payedAmount: 0,
      content: null,
      id: null,
      uid: null,
      step: 'header',
      items: [],
      currency_amount: 1,
      currency: null,
      entrepot: null,
      dueDate: null,
      date: null,
      more: false,
      account: null,
      accountId: null,
      loading: false,
      ouid: null,
      sumAmount: null,
      store: false,
      showSelectedItems: false,
      type: null,
      number: null,
      paymentButton: true,
      interval: null,
      connectedBank: null,
      connectToP3POS: null,
      connectedBankToP3: null,
      clearingStatus: null,
      paymentResult: null,
      beforeEditAmount: 0,
    }),
    computed: {
      paymentButtonStatus () {
        var status = true
        if (this.connectToP3POS === 'active' && this.connectedBankToP3 !== 'null') {
          status = false
        }
        return status
      },
      total () {
        return total
      },
      // total: function () {
      //   var sum = parseFloat(this.sum) - parseFloat((this.totalDiscount !== '' ? this.totalDiscount : 0))
      //   this.checkBankRemain(sum)
      //   return sum.toFixed(this.decimal)
      // },
    },
    watch: {
      step () {
        if (this.step === 'body') {
          // this.height = this.$refs.refMain.$el.offsetHeight
        }
      },
      items: {
        handler: function (val, oldVal) {
          var app = this
          app.sumAmount = 0
          for (let i = 0; i < this.items.length; i++) {
            app.sumAmount = +app.sumAmount + +(this.items[i].count * this.items[i].fee)
          }
        },
        deep: true,
      },
      wastageReturnSell (val) {
        // localStorage.setItem('wastageReturnSell', (val ? 'active' : null))
      },
    },
    beforeMount () {
      if (this.$route.name === 'mSell') {
        this.type = 'sell'
      }
      if (this.$route.name === 'mReturnSell') {
        this.type = 'returnSell'
      }
      if (this.$route.params.id != null) {
        this.render = false
        this.id = this.$route.params.id
      } else {
        this.render = true
      }
      if (this.$store.state.currency && !this.id && !this.account) {
        this.currency = this.$store.state.currency
        this.currency_amount = this.$store.state.currency.amount
      }
      var number = localStorage.getItem('invoiceNumber')
      if (!number || isNaN(number)) {
        this.number = 1
      } else {
        this.number = number++
      }
      if (localStorage.getItem('sellInvoiceWithoutCustomer') === 'true' && this.type === 'sell') {
        this.account = this.$store.state.defaultCustomer
        this.step = 'body'
      }
    },
    activated () {
      this.connectToP3POS = localStorage.getItem('connectToP3POS')
      this.connectedBankToP3 = localStorage.getItem('connectedBankToP3')
      if (this.$route.name === 'mSell') {
        this.type = 'sell'
      }
      if (this.$route.name === 'mReturnSell') {
        this.type = 'returnSell'
      }
      if (localStorage.getItem('sellInvoiceWithoutCustomer') === 'true' && this.type === 'sell') {
        this.account = this.$store.state.defaultCustomer
        this.step = 'body'
      }
      var number = localStorage.getItem('invoiceNumber')
      if (!number || isNaN(number)) {
        this.number = 1
      } else {
        this.number = number++
      }
      if (localStorage.getItem('sellInvoiceWithoutCustomer') === 'true' && this.type === 'sell') {
        this.account = this.$store.state.defaultCustomer
        this.step = 'body'
      }
      if (this.connectedBankToP3) {
        this.connectedBank = JSON.parse(this.connectedBankToP3)
      }
      this.clearForm()
    },
    mounted () {
      this.connectToP3POS = localStorage.getItem('connectToP3POS')
      this.connectedBankToP3 = localStorage.getItem('connectedBankToP3')
      if (this.connectedBankToP3) {
        this.connectedBank = JSON.parse(this.connectedBankToP3)
      }
    },
    methods: {
      setPaymentMode () {
        this.paymentModeDialog = true
      },
      sendInvoiceToPos (type) {
        if (type === 'remainCustomer') {
          this.paymentModePrice = (this.account ? this.account.remain : 0)
        }
        if (type === 'remainInvoice') {
          this.paymentModePrice = this.sumAmount
        }
        this.sendPOS = true
        this.createIdInvoice()
      },
      back () {
        if (this.step === 'body') {
          this.step = 'header'
        }
        if (this.step === 'final') {
          this.step = 'body'
        }
      },
      b64EncodeUnicode (str) {
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
                                                    function toSolidBytes (match, p1) {
                                                      return String.fromCharCode('0x' + p1)
                                                    }))
      },
      createIdInvoice () {
        var app = this
        this.$refs.form.inputs.forEach(e => {
          if (e.errorBucket && e.errorBucket.length) {
            app.snakbarText = e.errorBucket[0]
            app.snakbarColor = 'pink'
            app.snakbar = true
            return false
          }
        },
        )
        if (!this.items || (this.items && this.items.length === 0)) {
          app.snakbarText = this.$t('notItemsForSubmit')
          app.snakbarColor = 'pink'
          app.snakbar = true
          return false
        }
        if (!this.$refs.form.validate()) return false
        app.snakbar = false
        app.loading = true
        app.$axios.post(this.$endpoint + 'invoice', {
          createIdInvoice: 'active',
          account: app.account,
          type: app.type,
          date: app.date,
        })
          .then(res => {
            res = res.data
            app.id = res.id
            app.uid = res.uid
            app.create()
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      create () {
        var app = this
        var token = JSON.parse(localStorage.getItem('token'))
        this.ouid = token.init.userId + '@' + Date.now() + '@' + this.number
        var connection = app.DB
        connection.openDb('db_' + this.$store.state.userId)
        connection.select({
          from: 'invoice',
          aggregate: {
            max: 'number',
          },
        }).then(function (data) {
          if (data.length === 0) {
            app.number = 1
          } else {
            app.number = +data[0].number + 1
          }
          app.store = true
          var invoiceArray = app.makeInvoiceArray(app.$data)
          connection.insert({ into: 'invoice', values: invoiceArray })
          app.beforeEditAmount = app.sumAmount
          var invoice = JSON.stringify(invoiceArray)
          if (app.sendPOS && app.connectToP3POS === 'active' && app.connectedBankToP3) {
            app.clearingStatus = 'active'
            app.checkPaymentResult(invoiceArray[0])
            app.loadingText = 'waitingForPayment'
            app.loadingDialog = true
            localStorage.setItem('paymentLoading', 'active')
            window.location = 'p3integrator://request?amount=' + app.paymentModePrice + '&invoice=' + app.b64EncodeUnicode(invoice)
          } else {
            app.updateRemainPerson(app.account.id, (app.type === 'sell' ? app.sumAmount : -app.sumAmount))
            if (!app.wastageReturnSell) {
              app.updateStockProduct(invoiceArray[0])
            }
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
            app.clearForm()
            app.createInvoiceOffline()
            app.loading = false
            app.ouid = null
            if (app.connectToP3POS === 'active') {
              window.location = 'print://request?amount=' + app.sumAmount + '&invoice=' + app.b64EncodeUnicode(invoice)
            }
          }
        })
      },
      update () {
        var app = this
        this.$refs.form.inputs.forEach(e => {
          if (e.errorBucket && e.errorBucket.length) {
            app.snakbarText = e.errorBucket[0]
            app.snakbarColor = 'pink'
            app.snakbar = true
            return false
          }
        },
        )
        if (!this.items || (this.items && this.items.length === 0)) {
          app.snakbarText = this.$t('notItemsForSubmit')
          app.snakbarColor = 'pink'
          app.snakbar = true
          return false
        }
        if (!this.$refs.form.validate()) return false
        app.loading = true
        var connection = app.DB
        connection.openDb('db_' + this.$store.state.userId)
        connection.update({
          in: 'invoice',
          set: {
            store: true,
            date: app.date,
            items: app.items,
            account: app.account,
            accountId: app.account.id,
            branch: app.branch,
            currency: app.currency,
            dueDate: app.dueDate,
            sumAmount: app.sumAmount,
            // clearingStatus: app.clearingStatus,
            number: app.number,
            currency_amount: app.currency_amount,
            entrepot: app.entrepot,
            tax: app.tax,
            content: app.content,
          },
          where: {
            ouid: app.ouid,
          },
        }).then(function (data) {
          var amount = +app.sumAmount - +app.beforeEditAmount
          app.updateRemainPerson(app.account.id, (app.type === 'sell' ? amount : -amount))
          app.snakbarText = app.$t('registered')
          app.snakbarColor = 'green'
          app.snakbar = true
          app.clearForm()
          app.createInvoiceOffline()
          app.loading = false
        })
      },
      storeInServer () {
        // var list = JSON.parse(localStorage.getItem('invoice'))
      },
      makeInvoiceArray (data) {
        var array = [{
          abrName: this.$store.state.abrName,
          userId: this.$store.state.userId,
          autoPrint: true,
          date: data.date,
          items: data.items,
          account: data.account,
          accountId: data.account.id,
          branch: data.branch,
          currency: data.currency,
          type: data.type,
          dueDate: data.dueDate,
          ouid: data.ouid,
          sumAmount: data.sumAmount,
          store: data.store,
          number: data.number,
          currency_amount: data.currency_amount,
          entrepot: data.entrepot,
          id: data.id,
          uid: data.uid,
          tax: data.tax,
          payedAmount: data.payedAmount,
          content: data.content,
          clearingStatus: data.clearingStatus,
          bank: data.connectedBank,
          paymentResult: data.paymentResult,
        }]
        return array
      },
      checkPaymentResult (invoice) {
        var app = this
        var connection = app.DB
        connection.openDb('db_' + this.$store.state.userId)
        app.interval = setInterval(function () {
          var paymentLoading = localStorage.getItem('paymentLoading')
          if (paymentLoading === 'deactive') {
            clearInterval(app.interval)
            app.loading = false
            app.loadingDialog = false
          }
          connection.select({
            from: 'invoice',
            where: {
              ouid: invoice.ouid,
            },
          }).then(function (data) {
            app.clearingStatus = null
            if (data[0].paymentResult) {
              var result = JSON.parse(data[0].paymentResult)
              if (result.Status === 'ERROR') {
                app.snakbarColor = 'pink'
                app.snakbarText = result.Description
              } else {
                app.clearingStatus = 'active'
                app.paymentButton = false
                app.payedAmount = data[0].payedAmount
                app.snakbarColor = 'blue'
                app.snakbarText = app.$t('paymentIsSuccessful')
                app.updateRemainPerson(invoice.account.id, (invoice.type === 'sell' ? invoice.sumAmount : -invoice.sumAmount))
                if (!app.wastageReturnSell) {
                  app.updateStockProduct(invoice)
                }
                app.clearForm()
                app.createInvoiceOffline()
                app.ouid = null
              }
              app.loading = false
              app.snakbar = true
            }
            // connection.update({
            //   in: 'invoice',
            //   set: {
            //     store: true,
            //     clearingStatus: app.clearingStatus,
            //     paymentResult: JSON.stringify(data.payment),
            //   },
            //   where: {
            //     ouid: invoice.ouid,
            //   },
            // })
          })
        }, 2000)
      },
      clearForm () {
        this.selected = []
        this.render = true
        this.clearingStatus = null
        this.paymentButton = true
        this.wastageReturnSell = false
        this.store = false
        this.showSelectedItems = false
        if (this.$refs.productRef) {
          this.$refs.productRef.clearSelectedItems()
        }
        this.items = []
        this.account = null
        this.beforeEditAmount = 0
        this.step = 'header'
        this.loading = false
        this.$refs.form.resetValidation()
      },
      updateRemainPerson (accountId, amount) {
        var app = this
        var connection = app.DB
        connection.openDb('db_' + this.$store.state.userId)
        connection.select({
          from: 'person',
          where: {
            id: accountId,
          },
        }).then(function (data) {
          if (data.length > 0) {
            var remain = data[0].amount
            connection.update({
              in: 'person',
              set: {
                amount: +remain + +amount,
              },
              where: {
                id: accountId,
              },
            }).then(function (data) {
            })
          }
        })
      },
      updateStockProduct (invoice) {
        var app = this
        var connection = app.DB
        connection.openDb('db_' + this.$store.state.userId)
        invoice.items.map(function (value) {
          connection.select({
            from: 'products',
            where: {
              id: value.product.id,
            },
          }).then(function (data) {
            if (data.length > 0) {
              var remain = data[0].countStock
              connection.update({
                in: 'products',
                set: {
                  countStock: +remain + +(invoice.type === 'sell' ? -value.count : value.count),
                },
                where: {
                  id: value.product.id,
                },
              }).then(function (data) {
              })
            }
          })
        })
      },
    },
    beforeRouteLeave (to, from, next) {
      if (this.step === 'final') {
        this.step = 'body'
        this.goTo('mSell')
        next(false)
      } else if (this.step === 'body') {
        this.step = 'header'
        next(false)
      } else {
        if (this.$store.state.mobileDialogStatus) {
          this.$store.commit('SET_MOBILEDIALOGSTATUS', false)
          next(false)
        } else {
          this.leavePage(to, from, next)
        }
      }
      next(false)
    },
  }
</script>

<style  lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'
.mobile-view
  .v-text-field--outlined .v-label
    top: 12px
  .v-text-field--full-width .v-input__prepend-outer, .v-text-field--full-width .v-input__prepend-inner, .v-text-field--full-width .v-input__append-inner, .v-text-field--full-width .v-input__append-outer, .v-text-field--enclosed .v-input__prepend-outer, .v-text-field--enclosed .v-input__prepend-inner, .v-text-field--enclosed .v-input__append-inner, .v-text-field--enclosed .v-input__append-outer
    margin-top: 1px
  .v-card .v-divider
    border-color: #c2c2c2
</style>

<style scoped>
/*.v-text-field--outlined .v-label {*/
/*  top:0px; !important;*/
/*}*/
</style>
